




































import { Component, Vue, Watch } from 'vue-property-decorator'; // デコレータ
import ApiAccessBase from '../../CommonFeature/components/ApiAccessBase.vue';
import router from '../../router';
import { supervisingModule } from '../../store/modules/OperationSupervising';
/* 以下画面固有 */
import { Constants } from '../../CommonUtils/fixed/Constants'; // 定数保管ファイル
import { UketsukeConstants } from '../fixed/UketsukeConstants';
// コンポーネント登録
Vue.component('ApiAccessBase', ApiAccessBase);

/**
 * 2025.10.17 [R7年度改修作業（PKGエンハンス適用）] add
 */
@Component
export default class AccepterPasswordReconfig extends ApiAccessBase {
  private isRegist: boolean = false;
  private reconfigId: string = '';

  private getId() {
    let id = supervisingModule.GET_TENANT_ID;
    if (!id) {
      // クエリストリングからidの取得
      const tempId = this.$route.query.id;
      if (typeof tempId === 'string') {
        id = tempId;
        // ストアに保存
        supervisingModule.setTenantId(id);
      }
    }
    return id;
  }

  private getReconfig() {
    // クエリストリングからidの取得
    const reconfig = this.$route.query.reconfig;
    if (typeof reconfig === 'string') {
      this.reconfigId = reconfig;
    } else {
      this.reconfigId =  '';
    }
  }

  // 画面初期化処理
  // component生成時に実行
  private created() {
    this.screenTitle = 'パスワード再設定';
    this.getId();
    this.getReconfig();
    // 使用する可変項目の名前を指定(複数指定可)
    this.setVariablecolsState(['accepter_password_change']);
    // APIアクセス
    this.apiAccess(UketsukeConstants.PASSWORD_RECONFIG_PATH + '/init/' + supervisingModule.GET_TENANT_ID + '/' + this.reconfigId,
     Constants.API_METHOD_GET, false, false).then(
      (result) => {
        if ((result) === Constants.API_RESULT_SUCCES) {
          this.isRegist = true;
        }
      },
    );
  }

  private registData() {
    // formのバリデーション
    if (!this.validateForm(this.$refs.form)) {
      return;
    }
    // APIアクセス
    this.apiAccess(UketsukeConstants.PASSWORD_RECONFIG_PATH + '/update/' + supervisingModule.GET_TENANT_ID + '/' + this.reconfigId,
    Constants.API_METHOD_POST, true, false)
    .then((result) => {
      this.hrefElement('accepterPasswordReconfig', -50);
      if (result === Constants.API_RESULT_SUCCES) {
        // 画面説明強制リセット
        this.screenRemarks = '';
        this.isRegist = false;
      }
    });
  }

  /**
   * 戻る
   */
  private returnPrevious() {
    router.push('login');
  }
}
